export default __webpack_public_path__ + "static/media/beginImage2.eccc6dfa.webp";